import { Directive, Input, TemplateRef } from '@angular/core';

/** Šablona buňky: `<ng-template appDataTableCell="columnId" let-row="row">` */
@Directive({
  selector: '[appDataTableCell]',
})
export class DataTableCellDirective {
  @Input('appDataTableCell') columnId!: string;

  constructor(public readonly templateRef: TemplateRef<{ row: unknown }>) {}
}
